import { useMutation } from 'react-query';
import changeRoomServices from '../requests/changeRoomServices';

const useChangeRoomServicesMutation = (options) =>
  useMutation(
    ({ companyServices, room }) => changeRoomServices(companyServices, room),
    options
  );

export default useChangeRoomServicesMutation;
